function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { FieldLayout } from "#library/components/FieldLayout/FieldLayout";
import { Input } from "./Input";
export var InputField = function InputField(_ref) {
  var commonProps = _ref.commonProps,
    containerProps = _ref.containerProps,
    fieldProps = _ref.fieldProps,
    fieldWrapperProps = _ref.fieldWrapperProps,
    iconProps = _ref.iconProps,
    labelProps = _ref.labelProps,
    switchTextProps = _ref.switchTextProps;
  // Focus
  var onFocus = function onFocus(event) {
    // continue propagation
    if (fieldProps.onFocus) {
      fieldProps.onFocus(event);
    }
  };

  // Blur
  var onBlur = function onBlur(event) {
    // continue propagation
    if (fieldProps.onBlur) {
      fieldProps.onBlur(event);
    }
  };
  var labelPropsWithId = _objectSpread(_objectSpread({}, labelProps), {}, {
    id: fieldProps.id
  });
  return /*#__PURE__*/React.createElement(FieldLayout, {
    commonProps: commonProps,
    containerProps: containerProps,
    fieldWrapperProps: fieldWrapperProps,
    iconProps: iconProps,
    switchTextProps: switchTextProps,
    labelProps: labelPropsWithId
  }, /*#__PURE__*/React.createElement(Input
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, fieldProps, {
    required: (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.required) || (commonProps === null || commonProps === void 0 ? void 0 : commonProps.required),
    isDisabled: (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.isDisabled) || (commonProps === null || commonProps === void 0 ? void 0 : commonProps.isDisabled),
    hasRightIcon: iconProps && !!(iconProps !== null && iconProps !== void 0 && iconProps.icon),
    hasLeftIcon: iconProps && (iconProps === null || iconProps === void 0 ? void 0 : iconProps.hasIconOnLeft),
    hasError: (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.hasError) || (commonProps === null || commonProps === void 0 ? void 0 : commonProps.hasError),
    onFocus: onFocus,
    onBlur: onBlur
  })));
};